<template>
  <!--
    Form Radio:
      b-form-radio:class ==
        .form-group > div > .custom-control.custom-radio.gmb-radio-button
      b-form-radio > div:class ==
        .form-group > div > .custom-control.custom-radio.gmb-radio-button > div
  -->
  <b-form-radio
      class="d-flex mh-0 w-100 pl-0 gmb-radio-button"
      :name="name"
      ref="bsRadioButton"
      size="sm"
      :value="value"
      @click.native.stop
      @input="
      (bsRadioButtonGroupNewActivatedValue) =>
        onActivatedValueChanged(bsRadioButtonGroupNewActivatedValue)
    "
  />
</template>

<script>
export default {
  name: "GmbRadioButton",

  components: {},

  props: {
    name: String,
    value: String,
  },

  data() {
    return {
      isActivated: undefined,
    };
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
    this.isActivated = this.$refs.bsRadioButton.isChecked;
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    onActivatedValueChanged(bsRadioButtonGroupNewActivatedValue) {
      this.isActivated = bsRadioButtonGroupNewActivatedValue == this.value;
      this.$emit("state-changed", this.isActivated);
    },
  },
};
</script>

<style lang="scss">
@import "@/sass/settings/dimensions";

/* =========================================================================
 * RADIO BUTTON
 * ========================================================================= */

.gmb-radio-button {
  &.custom-radio {
    &.custom-control {
      &.custom-control-inline {
        margin-right: unset;
      }

      & *:hover {
        cursor: pointer;
      }

      & > .custom-control-input {
        height: unset;
      }

      & > .custom-control-label {
        display: flex;
        flex-grow: 1;
        width: 0;

        &::before {
          position: unset;

          flex-shrink: 0;
          // border: none;
          width: $gmb-offset-3;
          height: $gmb-offset-3;
        }

        &::after {
          // display: none;

          // top: unset;
          // left: unset;
          left: 0px;
          top: 0px;
        }
      }
    }
  }
}
</style>
